<div *ngIf="globals.storeSettings && order">
  <br />
  <div class="row">
    <div class="col">
      <h2>{{ 'Order' | translate }} {{order.orderNumber}}</h2>
    </div>
    <div class="col align-right" *ngIf="globals.userIsAce()">
      <button class="styled slim" *ngIf="['PENDING', 'READY', 'ERROR'].includes(order.status)" mat-raised-button
        color="primary" (click)="cancelOrder()">{{ 'Avbryt order' | translate }}</button>

      <button class="styled slim" *ngIf="(!order.metadata || !order.metadata.reclaimNewOrderNumber)"
        [routerLink]="[globals.panelUrl('/reclaim-order/' + order._id)]" mat-raised-button color="primary">{{ 'Reklamera' | translate }}</button>
    </div>
  </div>


  <mat-tab-group>
    <mat-tab [label]="'Generellt' | translate" #generalTab>
      <br />
      <div *ngIf="generalTab.isActive">

        <div class="row" *ngIf="isEditable()">
          <div class="col-4">
            <mat-form-field class="fullwidth">
              <mat-label>{{ 'Förnamn' | translate }}</mat-label>
              <input type="text" matInput [(ngModel)]="order.shippingInfo.firstName">
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field class="fullwidth">
              <mat-label>{{ 'Efternamn' | translate }}</mat-label>
              <input type="text" matInput [(ngModel)]="order.shippingInfo.lastName">
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field class="fullwidth">
              <mat-label>{{ 'Epost' | translate }}</mat-label>
              <input type="text" matInput [(ngModel)]="order.shippingInfo.email">
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field class="fullwidth">
              <mat-label>{{ 'Telefon' | translate }}</mat-label>
              <input type="text" matInput [(ngModel)]="order.shippingInfo.phone">
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field class="fullwidth">
              <mat-label>{{ 'Adress' | translate }}</mat-label>
              <input type="text" matInput [(ngModel)]="order.shippingInfo.address1">
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field class="fullwidth">
              <mat-label>{{ 'Postkod' | translate }}</mat-label>
              <input type="text" matInput [(ngModel)]="order.shippingInfo.zipCode">
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field class="fullwidth">
              <mat-label>{{ 'Ort' | translate }}</mat-label>
              <input type="text" matInput [(ngModel)]="order.shippingInfo.city">
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field class="fullwidth">
              <mat-label>{{ 'Företag' | translate }}</mat-label>
              <input type="text" matInput [(ngModel)]="order.shippingInfo.company">
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field class="">
              <mat-label>{{ 'Land' | translate }}</mat-label>
              <mat-select [(ngModel)]="order.shippingInfo.country">
                <mat-option *ngFor="let country of availableCountryCodes" [value]="country">{{country}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-4" *ngIf="globals.userIsAce()">
            <mat-checkbox [(ngModel)]="order.ignoreFreezePeriod" color="primary">{{ 'Prioritera print' | translate }}</mat-checkbox>
          </div>
          <div class="col-12 align-right">
            <button class="styled" mat-raised-button color="primary" (click)="save()">{{ 'Spara' | translate }}</button>
          </div>
        </div>




        <div class="row" *ngIf="!isEditable()">
          <div class="col-4">
            <h6>{{ 'Namn' | translate }}</h6>
            <h5>{{order.shippingInfo.firstName}} {{order.shippingInfo.lastName}}</h5>
          </div>
          <div class="col-4">
            <h6>{{ 'E-post' | translate }}</h6>
            <h5>{{order.shippingInfo.email}}</h5>
          </div>
          <div class="col-4">
            <h6>{{ 'Telefon' | translate }}</h6>
            <h5>{{order.shippingInfo.phone}}</h5>
          </div>
          <div class="col-4">
            <h6>{{ 'Adress' | translate }}</h6>
            <h5>{{order.shippingInfo.address1}}</h5>
          </div>
          <div class="col-4">
            <h6>{{ 'Postkod' | translate }}</h6>
            <h5>{{order.shippingInfo.zipCode}}</h5>
          </div>
          <div class="col-4">
            <h6>{{ 'Ort' | translate }}</h6>
            <h5>{{order.shippingInfo.city}}</h5>
          </div>
          <div class="col-4">
            <h6>{{ 'Företag' | translate }}</h6>
            <h5>{{order.shippingInfo.company}}</h5>
          </div>
          <div class="col-4">
            <h6>{{ 'Land' | translate }}</h6>
            <h5>{{order.shippingInfo.country}}</h5>
          </div>
          <div class="col-4"
            *ngIf="order.thirdParty && order.thirdParty.exakta && order.thirdParty.exakta.trackingInfo">
            <h6>{{ 'Spårning' | translate }}</h6>
            <a href="{{order.thirdParty.exakta.trackingInfo.trackingUrl}}" target="_blank"><span
                class="material-symbols-outlined partner-color">local_shipping</span></a>
          </div>
        </div>
        <br />
        <hr>
        <br />
        <div class="row">
          <div class="col">
            <table class="fullwidth styled">
              <tr *ngFor="let item of order.items">
                <td>
                  {{item.quantity}}x
                </td>
                <td>
                  <div *ngIf="globals.currentUser">
                    <order-item-administration [item]="item" [order]="order" [showSku]="true"></order-item-administration>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab [label]="'Frakt' | translate" *ngIf="order.shippingDispatches && order.shippingDispatches.length" #shippingTab>
      <br />
      <div class="row">
        <div class="col">
          <table class="fullwidth styled">
            <tr *ngFor="let dispatch of order.shippingDispatches">
              <td>
                {{dispatch.dispatchDate | date : 'yyyy-MM-dd HH:mm'}}
              </td>
              <td>
                <a href="{{dispatch.trackingUrl}}" target="_blank">{{dispatch.trackingNumber}}</a>
              </td>
              <td>
                <div *ngFor="let item of dispatch.dispatchedItems">
                  {{item.quantity}}x {{item.name}}
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </mat-tab>
    <mat-tab [label]="'Logg' | translate" #logTab>
      <br />
      <div *ngIf="logTab.isActive">
        <table class="fullwidth styled log">
          <tr *ngFor="let logItem of order.log" class="log-item {{logItem.severity}}"
            [ngClass]="{'admin-color': logItem.adminOnly}">
            <ng-container *ngIf="globals.currentUser.role == 'ACE' || !logItem.adminOnly">
              <td>{{logItem.created | date : 'yyyy-MM-dd HH:mm'}}</td>
              <td>{{logItem.message}}</td>
            </ng-container>
          </tr>
        </table>
      </div>
    </mat-tab>

    <mat-tab label="" #adminTab *ngIf="globals.currentUser.role == 'ACE'">
      <ng-template mat-tab-label>
        <span class="admin-color">{{ 'Superadmin' | translate }}</span>
      </ng-template>
      <br />
      <div *ngIf="adminTab.isActive">
        <div *ngIf="globals.storeSettings.type == 'partner' && order.processingFee">
          <h3>{{ 'Pris' | translate }}</h3>
          <div class="row">
            <div class="col-4">
              <mat-form-field class="fullwidth">
                <label>{{ 'Print' | translate }}</label>
                <input matInput type="number" [(ngModel)]="order.processingFee.printCost" />
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field class="fullwidth">
                <label>{{ 'Frakt' | translate }}</label>
                <input matInput type="number" [(ngModel)]="order.processingFee.shippingCost" />
              </mat-form-field>
            </div>
            <div class="col-4">
              <br />
              <button class="styled" mat-raised-button color="primary" (click)="updateProcessingFee()">{{ 'Ändra' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

  </mat-tab-group>

</div>